'use strict';

export const MultiBuyerConstants = Object.freeze({
  // ── Entity user context ──────────────────────────────────────────────────
  // access-token: entity token | service-user-id: apiUserId

  PAGES_THAT_NEED_ENTITY_USER: [
    '/dashboard',
    '/create-surveys',
    '/create-templates',
    '/launch-survey',
    '/edit',
    '/suppliers',
    '/recontact-survey',
    '/manage-buyer-settings',
    '/manage-suppliers',
  ] as string[],

  ROUTES_THAT_NEED_ENTITY_USER: [] as string[],

  // ── Umbrella user context ─────────────────────────────────────────────────
  // access-token: umbrella token | service-user-id: umbrella userId

  PAGES_THAT_FORCE_UMBRELLA_USER: [] as string[],

  ROUTES_THAT_FORCE_UMBRELLA_USER: [
    '/variable-margin',
    '/multi-surveys',
    '/getUserToken',
    '/v2/rmf/fileupload',
  ] as string[],

  // ── API user context ──────────────────────────────────────────────────────
  // access-token: entity token | service-user-id: apiUserId (elevated backend access)

  PAGES_THAT_NEED_API_USER: [] as string[],

  ROUTES_THAT_NEED_API_USER: ['/buyers', '/ps-reports-service'] as string[],
});
